import { useEffect, useState } from 'react';

import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { color } from '../../styles/GlobalStyles';
import { getDashboardInfo, getTeamInfo } from './Dashboard.actions';

import { Box, Flexed, SlideWrapper } from '../../styles/GlobalComponents';
import { DashboardNav } from './DashboardNav';

import 'swiper/css';
import 'swiper/css/navigation';

import Modal from 'react-modal';
import advertisementHub1 from '../../assets/images/backoffice/ad1.png';
import advertisementHub2 from '../../assets/images/backoffice/ad2.png';
import advertisementHub3 from '../../assets/images/backoffice/ad3.png';
import advertisementHub4 from '../../assets/images/backoffice/ad4.png';

import { H2, H3, H4, P2, P3 } from '../../styles/FontStyles';
import MigrationTermsPrivacy from '../MigrationTermsPrivacy/MigrationTermsPrivacy';

import {
  isCountryAllowed,
  isPartnerHelper
} from '../../helpers/helperFunctions';
import { getCurrentLicense } from '../../slices/auth-slice';
import SignUp from '../SignUp/SignUp';
import { EarningsComponent } from './EarningsComponent';

import { Navigation, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import topPerformerUnderlay from '../../assets/images/topPerformerBack.png';

import { getRanking } from '../Ranking/Ranking.actions';
import { TopSponsorPerformer } from './common/TopSponsorPerformer';
import { Ranking } from '../Ranking/Ranking';

import bangladeshBanner from '../../assets/images/backoffice/dashboard/bangladeshBanner.png';
import bangladeshBannerMobile from '../../assets/images/backoffice/dashboard/bangladeshBannerMobile.png';
import afrikaBanner from '../../assets/images/backoffice/dashboard/afrikaBanner.png';
import afrikaBannerMobile from '../../assets/images/backoffice/dashboard/afrikaBannerMobile.png';
import afrikaBannerCustomer from '../../assets/images/backoffice/dashboard/afrikaBannerCustomer.png';
import bangladeshBannerCustomer from '../../assets/images/backoffice/dashboard/bangladeshBannerCustomer.png';

import minaraBanner from '../../assets/images/backoffice/dashboard/minaraBanner.png';
import futuraMiningBanner from '../../assets/images/backoffice/dashboard/futuraMiningBanner.png';
import unitedOneBanner from '../../assets/images/backoffice/dashboard/unitedOne.png';

import minaraBannerMobile from '../../assets/images/backoffice/dashboard/minaraMobile.png';
import futuraMiningBannerMobile from '../../assets/images/backoffice/dashboard/futuraMiningMobile.png';
import unitedOneBannerMobile from '../../assets/images/backoffice/dashboard/unitedOneMobile.png';

import { Link } from 'react-router-dom';
import {
  ENTRY_PACKAGE,
  MY_HUBS_FUTURA_MINING,
  MY_HUBS_MINARA
} from '../../routes/routes';
import { getCashback } from '../CashbackBonus/CashbackBonus.actions';

export enum UserType {
  CUSTOMER = 1,
  PARTNER
}

const Dashboard = () => {
  const [futuraMining, setFuturaMining] = useState('');

  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [termsConditionsModal, setTermsConditionsModal] = useState(false);
  const [userTypeModal, setUserTypeModal] = useState(false);

  const [userType, setUserType] = useState(UserType.CUSTOMER);
  const { dashboardInfo, loading } = useAppSelector((state) => state.dashboard);

  const user = userInfo.user;

  const isPartner = isPartnerHelper(
    dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd || ''
  );

  const { ranking, loading: rankingLoading } = useAppSelector(
    (state) => state.ranking
  );

  const fetchData = async () => {
    try {
      const res = await fetch(
        'https://mining-api.futura-mining.com/api/statistics/'
      );
      const data = await res.json();

      setFuturaMining(data?.total_rewards);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!userInfo.isFirstLoginPopupChecked) {
      dispatch(getCurrentLicense());
      setUserTypeModal(true);
    } else if (!userInfo.isMavieMigrationModalChecked) {
      dispatch(getCurrentLicense());
      setTermsConditionsModal(true);
    }

    dispatch(getDashboardInfo());

    if (isPartner) {
      dispatch(getTeamInfo());
      dispatch(getCashback());
      dispatch(getRanking());
    }

    fetchData();
  }, [dispatch, userInfo.isMavieMigrationModalChecked, isPartner]);

  if (loading || (rankingLoading && !dashboardInfo))
    return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <Flexed gap='20px' rowSM width='100%'>
        {!isPartner && (
          <Flexed width='30%' widthSM='100%'>
            <Box
              style={{ width: '100%', marginBottom: 0 }}
              p='46px 36px'
              pSM='46px 36px'
              mSM='0'
              mbSM='0'>
              <DashboardNav user={user} userInfo={userInfo} />
            </Box>
          </Flexed>
        )}
        <Flexed
          column
          width={isPartner ? '100%' : '70%'}
          widthSM='100%'
          gap='20px'>
          <Desktop>
            <SlideWrapper width='100%' margin='0 24px 0px 0'>
              <Swiper
                slidesPerView={1.05}
                modules={[Navigation]}
                navigation={true}
                spaceBetween={10}
                loop={true}
                centeredSlides={false}>
                <SwiperSlide>
                  <Link to={MY_HUBS_FUTURA_MINING}>
                    <div style={{ position: 'relative' }}>
                      <img
                        src={futuraMiningBanner}
                        alt='futuraaMining hub 2'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </div>
                    <P2
                      caps
                      color={'#fff'}
                      style={{
                        position: 'absolute',
                        bottom: isPartner ? 50 : 20,
                        left: 50
                      }}>
                      Be part of the{' '}
                      <span style={{ fontWeight: 'bold' }}>
                        {futuraMining} BTC
                      </span>{' '}
                      BTC already mined <br />
                      through the Futura dashboard. Start
                      <br /> mining your Bitcoin today.
                    </P2>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link to={ENTRY_PACKAGE}>
                    <img
                      src={unitedOneBanner}
                      alt='unitedOneBanner hub 1'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Link>
                </SwiperSlide>

                <SwiperSlide>
                  <Link to={MY_HUBS_MINARA}>
                    <img
                      src={minaraBanner}
                      alt='minaraBanner hub 1'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Link>
                </SwiperSlide>
              </Swiper>
            </SlideWrapper>
          </Desktop>
          <Mobile>
            <SlideWrapper width='calc(100%)' margin='0 24px 0px 0'>
              <Swiper
                slidesPerView={1}
                modules={[Navigation]}
                navigation={true}
                spaceBetween={10}
                centeredSlides={true}
                loop={true}>
                <SwiperSlide>
                  <Link to={MY_HUBS_FUTURA_MINING}>
                    <div style={{ position: 'relative' }}>
                      <img
                        src={futuraMiningBannerMobile}
                        alt='futuraaMining hub 2'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </div>
                    <P2
                      color={'#fff'}
                      style={{ position: 'absolute', bottom: 90, left: 50 }}>
                      Join the mining community. Be part of the <br />
                      <span style={{ fontWeight: 'bold' }}>
                        {futuraMining} BTC
                      </span>{' '}
                      already mined through the <br /> Futura dashboard. Start
                      mining your Bitcoin today.
                    </P2>
                  </Link>
                </SwiperSlide>
                <SwiperSlide>
                  <Link to={ENTRY_PACKAGE}>
                    <img
                      src={unitedOneBannerMobile}
                      alt='unitedOneBanner hub 1'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Link>
                </SwiperSlide>

                <SwiperSlide>
                  <Link to={MY_HUBS_MINARA}>
                    <img
                      src={minaraBannerMobile}
                      alt='minaraBanner hub 1'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Link>
                </SwiperSlide>
              </Swiper>
            </SlideWrapper>
          </Mobile>

          {!isPartner && (
            <>
              {user?.countryCode === 'BD' && (
                <Link to={ENTRY_PACKAGE}>
                  <Desktop>
                    <img
                      src={bangladeshBannerCustomer}
                      alt='bangladeshBanner'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Desktop>
                  <Mobile>
                    <img
                      src={bangladeshBannerMobile}
                      alt='bangladeshBannerMobile'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Mobile>
                </Link>
              )}

              {isCountryAllowed(user?.countryCode) && (
                <Link to={ENTRY_PACKAGE}>
                  <Desktop>
                    <img
                      src={afrikaBannerCustomer}
                      alt='afrikaBanner'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Desktop>
                  <Mobile>
                    <img
                      src={afrikaBannerMobile}
                      alt='afrikaBannerMobile'
                      style={{ width: '100%', cursor: 'pointer' }}
                    />
                  </Mobile>
                </Link>
              )}
            </>
          )}
          {isPartner && (
            <Flexed gap='20px' rowSM width='100%'>
              <Flexed column width='45%' widthSM='100%' gap='20px'>
                {user?.countryCode === 'BD' && (
                  <Link to={ENTRY_PACKAGE}>
                    <Desktop>
                      <img
                        src={bangladeshBanner}
                        alt='bangladeshBanner'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </Desktop>
                    <Mobile>
                      <img
                        src={bangladeshBannerMobile}
                        alt='bangladeshBannerMobile'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </Mobile>
                  </Link>
                )}

                {isCountryAllowed(user?.countryCode) && (
                  <Link to={ENTRY_PACKAGE}>
                    <Desktop>
                      <img
                        src={afrikaBanner}
                        alt='afrikaBanner'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </Desktop>
                    <Mobile>
                      <img
                        src={afrikaBannerMobile}
                        alt='afrikaBannerMobile'
                        style={{ width: '100%', cursor: 'pointer' }}
                      />
                    </Mobile>
                  </Link>
                )}

                {isPartner && (
                  <div style={{ width: '100%' }}>
                    <EarningsComponent user={user} backOffice={dashboardInfo} />
                  </div>
                )}
                {isPartner && ranking && ranking.length > 0 && (
                  <Ranking ranking={ranking} isDashboard={true} />
                )}
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  style={{ marginBottom: 0 }}>
                  <H4
                    fontFamily='Nulshock'
                    caps
                    color={color.colors.primary900}
                    mb='20'>
                    Advertisement hub
                  </H4>

                  <SlideWrapper width='calc(100%)' margin='0 24px 0px 0px'>
                    <Swiper
                      slidesPerView={1.2}
                      modules={[Autoplay, Navigation]}
                      navigation={true}
                      spaceBetween={10}
                      centeredSlides={false}
                      loop={true}
                      autoplay={{
                        delay: 5000,
                        disableOnInteraction: false
                      }}>
                      <SwiperSlide>
                        <a
                          href=' https://futura-mining.com'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub3}
                            alt='advertisement hub 2'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://www.unicapay.com'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub1}
                            alt='advertisement hub 1'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://minara.ai/home'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub2}
                            alt='advertisement hub 2'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                      <SwiperSlide>
                        <a
                          href='https://lms.unitedone.global/login'
                          target='_blank'
                          rel='noreferrer'>
                          <img
                            src={advertisementHub4}
                            alt='advertisement hub 2'
                            style={{ width: '100%' }}
                          />
                        </a>
                      </SwiperSlide>
                    </Swiper>
                  </SlideWrapper>
                </Box>
              </Flexed>

              {isPartner && (
                <Box
                  relative
                  overflow='hidden'
                  m='0'
                  p='20px 20px 20px 40px'
                  style={{ marginBottom: 0 }}
                  bg={`url(${topPerformerUnderlay})`}
                  bgSize='cover'
                  bgPosition='center'
                  bgRepeat='no-repeat'>
                  <Flexed justifyCenter mb='15'>
                    <H2
                      fontFamily='Nulshock'
                      m='15px'
                      color={color.colors.primary900}>
                      My journey to success
                    </H2>
                  </Flexed>
                  <TopSponsorPerformer ranking={ranking} />
                </Box>
                // <Box
                //   relative
                //   overflow='hidden'
                //   m='0'
                //   style={{ marginBottom: 0 }}
                //   bg={`url(${topPerformerUnderlay})`}
                //   bgSize='cover'
                //   bgPosition='center'
                //   bgRepeat='no-repeat'>
                //   <TopSponsorPerformer user={user} index={0} />
                //   <TopSponsorPerformer user={user} index={1} />
                //   <TopSponsorPerformer user={user} index={2} />
                //   <TopSponsorPerformer user={user} index={3} />
                //   <TopSponsorPerformer user={user} index={4} />
                //   <TopSponsorPerformer user={user} index={5} />
                //   <TopSponsorPerformer user={user} index={6} />
                //   <TopSponsorPerformer user={user} index={7} />
                //   <TopSponsorPerformer user={user} index={8} />
                //   <TopSponsorPerformer user={user} index={9} />
                //   <TopSponsorPerformer user={user} index={10} />
                //   <TopSponsorPerformer user={user} index={11} />
                //   <TopSponsorPerformer user={user} index={12} />
                //   <TopSponsorPerformer user={user} index={13} />
                //   <TopSponsorPerformer user={user} index={14} />

                //   <TopPerformerOverlay>
                //     <H3 color={color.colors.primary900}>COMING SOON</H3>
                //   </TopPerformerOverlay>
                // </Box>
              )}
            </Flexed>
          )}
          {!isPartner && (
            <>
              <Flexed gap='20px' rowSM width='100%'>
                <Flexed column width='50%' widthSM='100%'>
                  <a
                    href=' https://futura-mining.com'
                    target='_blank'
                    rel='noreferrer'>
                    <img
                      src={advertisementHub3}
                      alt='advertisement hub 1'
                      style={{ width: '100%' }}
                    />
                  </a>
                </Flexed>
                <Flexed column width='50%' widthSM='100%'>
                  <a
                    href='https://www.unicapay.com'
                    target='_blank'
                    rel='noreferrer'>
                    <img
                      src={advertisementHub1}
                      alt='advertisement hub 1'
                      style={{ width: '100%' }}
                    />
                  </a>
                </Flexed>
              </Flexed>
              <Flexed gap='20px' rowSM width='100%'>
                <Flexed column width='50%' widthSM='100%'>
                  <a
                    href='https://minara.ai/home'
                    target='_blank'
                    rel='noreferrer'>
                    <img
                      src={advertisementHub2}
                      alt='advertisement hub 2'
                      style={{ width: '100%' }}
                    />
                  </a>
                </Flexed>
                <Flexed column width='50%' widthSM='100%'>
                  <a
                    href='https://lms.unitedone.global/login'
                    target='_blank'
                    rel='noreferrer'>
                    <img
                      src={advertisementHub4}
                      alt='advertisement hub 2'
                      style={{ width: '100%' }}
                    />
                  </a>
                </Flexed>
              </Flexed>
            </>
          )}
        </Flexed>
      </Flexed>

      <Modal
        isOpen={userTypeModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <SignUp
          setUserTypeModal={setUserTypeModal}
          setTermsConditionsModal={setTermsConditionsModal}
          setUserType={setUserType}
        />
      </Modal>
      <Modal
        isOpen={termsConditionsModal}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <MigrationTermsPrivacy
          setTermsConditionsModal={setTermsConditionsModal}
          isMavieMigrationModalChecked={userInfo?.isMavieMigrationModalChecked}
          userType={userType}
        />
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;
